import { render, staticRenderFns } from "./left.vue?vue&type=template&id=4b4cb22e&scoped=true&"
import script from "./left.vue?vue&type=script&lang=js&"
export * from "./left.vue?vue&type=script&lang=js&"
import style0 from "./left.vue?vue&type=style&index=0&id=4b4cb22e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4cb22e",
  null
  
)

export default component.exports